import Logo from './assets/logo.svg'

const Redirect = () => {
    return (
        <>
            <meta httpEquiv="refresh" content="0; URL=https://discord.com/invite/8Uw4wjc7nW" />
            <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '1.5rem', textAlign: 'center', padding: '2rem' }}>
                <img src={Logo} style={{ width: '140px', height: '140px' }} alt="Vinewood Multiplayer" />
                <h2 style={{ fontSize: '2rem' }}>Te redirecționăm pe Discord…</h2>
                <p style={{ fontSize: '1.1rem', color: 'var(--muted)' }}>
                    Dacă nu se întâmplă nimic, <a href="https://discord.com/invite/8Uw4wjc7nW" style={{ color: '#c9a9ff' }}>apasă aici</a>.
                </p>
            </div>
        </>
    )
}

export default Redirect
